import { useState } from 'react';

import { SearchOutlined } from '@ant-design/icons';
import { Tabs, Input, Card, Button, Empty, Spin, message } from 'antd';
import type { TabsProps } from 'antd';

import { useMyCompanies } from '@/features/login/api/getMyCompanies';
import { useAuth } from '@/hooks/useAuth';
import { useCurrentCompanyId } from '@/hooks/useCurrentCompanyId';
import { useDisclosure } from '@/hooks/useDisclosure';

import { ServiceRequestDrawer } from './ServiceRequestDrawer';
import { ServiceItem } from './serviceTypes';
import { createServiceTicket } from './zendesk';

const dataSource: ServiceItem[] = [
  {
    key: '1',
    categoria: 'SUPORTE',
    item: 'WEBSITE',
    detalhamento:
      'Edição e upload de conteúdos de textos, banners, pop-up/splashes, imagens, documentos, eventos da agenda, gráficos e cotações/charts. Relatórios de analytics com dados de acessos como dispositivos utilizados, quantidade de downloads e visualizações',
  },
  {
    key: '2',
    categoria: 'SUPORTE',
    item: 'CAMPANHAS / MAILER',
    detalhamento:
      'Criação, envio de testes, agendamento e disparos de campanhas via e-mail. Disponibilização de relatórios de entrega.',
  },

  {
    key: '3',
    categoria: 'SUPORTE',
    item: 'WEBCAST / CONFERENCE CALLS',
    detalhamento:
      'Suporte completo para criação, agendamento e operação de eventos online via Zoom, Apoio junto aos fornecedores como intérprete, transcrição e mestre de cerimônia, Relatório de audiência.',
  },

  {
    key: '4',
    categoria: 'SUPORTE',
    item: 'ARQUIVAMENTOS CVM',
    detalhamento:
      'Arquivamentos na CVM, plataformas ENET E CICORP. Exemplos de documentos: Reunião da Administração, Políticas, Comunicado ao Mercado, Fato Relevante, Aviso aos Acionistas, Acordo de Acionistas.  Obs.: Para apoio no preenchimento e revisão de documentos estruturados, procure pelo nome do documento desejado.',
  },

  {
    key: '5',
    categoria: 'SUPORTE',
    item: 'REDE DIVULGAÇÃO',
    detalhamento:
      'Publicação de Fatos Relevantes e Comunicados ao Mercado no Portal rededivulgacao.com.br',
  },

  {
    key: '6',
    categoria: 'SUPORTE',
    item: 'TRADUÇÃO DE LAUDAS',
    detalhamento:
      'Análise, orçamento e prazo para tradução de documentos com base na quantidade de laudas (1 lauda = 160 palavras).',
  },

  {
    key: '7',
    categoria: 'SUPORTE',
    item: 'TRADUÇÕES DE ÁUDIO',
    detalhamento: 'Análise, orçamento e prazo para tradução de áudio com base na minutagem total.',
  },

  {
    key: '8',
    categoria: 'SUPORTE',
    item: 'TRANSCRIÇÕES',
    detalhamento:
      'Análise, orçamento e prazo para transcrição de áudios e vídeos com base na minutagem total.',
  },

  {
    key: '9',
    categoria: 'SUPORTE',
    item: 'AUDITORIA',
    detalhamento: 'Análise de logs e histórico de atualizações na plataforma.',
  },

  {
    key: '10',
    categoria: 'SUPORTE',
    item: 'TREINAMENTOS / ONBOARDING',
    detalhamento:
      'Treinamentos voltados à usabilidade da plataforma Workr para novos usuários ou atualização da equipe.',
  },

  {
    key: '11',
    categoria: 'SUPORTE',
    item: 'STATUS PLATAFORMA',
    detalhamento:
      'Verificações e suporte frente a falhas, lentidão, erros de upload/download ou bugs gerais da ferramenta. Informações técnicas de segurança, análise de pentests e respectivos planos de ação.',
  },

  {
    key: '12',
    categoria: 'SUPORTE',
    item: 'GESTÃO DE CONTAS E USUÁRIOS',
    detalhamento:
      'Criação, edição, exclusão de acessos e redefinição de senhas de usuários cadastrados.',
  },

  {
    key: '13',
    categoria: 'SUPORTE',
    item: 'DÚVIDAS, CRÍTICAS E SUGESTÕES',
    detalhamento:
      'Canal aberto para dúvidas, críticas, sugestões e feedbacks visando a evolução contínua da plataforma.',
  },

  {
    key: '14',
    categoria: 'ATENDIMENTO CVM/B3',
    item: 'DIVULGAÇÃO DE RESULTADOS',
    detalhamento:
      'Apoio em Release de Resultados, Apresentação, Relatório da Administração e Planilha Interativa. Elaboração/Atualização de conteúdo, gráficos e tabelas, incluindo checagem de informações com os quadros da DF.',
  },

  {
    key: '15',
    categoria: 'ATENDIMENTO CVM/B3',
    item: 'ITR/DFP',
    detalhamento: 'Revisão de valores e/ou Inserção das informações no ENET',
  },

  {
    key: '16',
    categoria: 'ATENDIMENTO CVM/B3',
    item: 'FRE - Formulário de Referência ',
    detalhamento:
      'Atualização anual, com inserção dos itens estruturados no ENET. Desenvolvimento dos itens destinados ao time de RI e/ou informações públicas.  Revisão e controle das pendências e áreas envolvidas. Reapresentações e atualizações pontuais.',
  },

  {
    key: '17',
    categoria: 'ATENDIMENTO CVM/B3',
    item: 'FCA - Formulário Cadastral',
    detalhamento: 'Atualização e inserção dos itens estruturados no sistema ENET.',
  },

  {
    key: '18',
    categoria: 'ATENDIMENTO CVM/B3',
    item: 'Informe do Código de Governança',
    detalhamento: 'Inserção dos itens estruturados no sistema ENET',
  },

  {
    key: '19',
    categoria: 'ATENDIMENTO CVM/B3',
    item: 'Documentos de Assembleias AGO / AGE / AGOE',
    detalhamento:
      'Elaboração dos documentos obrigatórios para realização das Assembleias, como Edital de Convocação, Proposta da Administração, Manual de Participação, BVD (Boletim de Voto à distância), Mapa Sintético Consolidado, Mapa Final de Votação Detalhado, Ata da Assembleia.',
  },

  {
    key: '21',
    categoria: 'ATENDIMENTO CVM/B3',
    item: 'Calendário de Eventos Corporativo',
    detalhamento: 'Inserção dos itens estruturados no sistema ENET e reapresentações',
  },

  {
    key: '22',
    categoria: 'ATENDIMENTO CVM/B3',
    item: 'Formulário RCVM 44/21',
    detalhamento:
      'Controle da Movimentação mensal da administração e tesouraria. Acompanhamento e input de movimentações no sistema ENET.',
  },

  {
    key: '23',
    categoria: 'ATENDIMENTO CVM/B3',
    item: 'Controle de Blackout',
    detalhamento: 'Apoio na comunicação com stakeholders e controle da rotina de blackout',
  },

  {
    key: '24',
    categoria: 'ATENDIMENTO CVM/B3',
    item: 'DESIGN - LAYOUT E DIAGRAMAÇÃO',
    detalhamento:
      'Criação ou atualização de materiais como: templates de e-mail, releases de resultado, apresentações institucionais, relatórios de sustentabilidade, relatos integrados e outros.',
  },

  {
    key: '26',
    categoria: 'CONSULTORIA E PROJETOS',
    item: 'DESIGN - BRANDING / MARCA',
    detalhamento:
      'Criação e/ou atualização de elementos de identidade visual, como logo, manual da marca e kit institucional (documentos timbrados).',
  },

  {
    key: '27',
    categoria: 'CONSULTORIA E PROJETOS',
    item: 'DESENVOLVIMENTO DE SITE',
    detalhamento:
      'Criação e/ou reformulação de sites institucionais, áreas de RI, ESG, hotsites para eventos, Investor Day e similares.',
  },

  {
    key: '28',
    categoria: 'CONSULTORIA E PROJETOS',
    item: 'EDIÇÃO DE VÍDEO',
    detalhamento:
      'Criação e edição de vídeos institucionais, shorts de resultado, vinhetas e publicações para redes sociais (LinkedIn, Instagram).',
  },

  {
    key: '29',
    categoria: 'CONSULTORIA E PROJETOS',
    item: 'TREINAMENTOS IN COMPANY',
    detalhamento:
      'Workshops e treinamentos especializados em Relações com Investidores, com foco técnico e prático.',
  },

  {
    key: '30',
    categoria: 'CONSULTORIA E PROJETOS',
    item: 'GESTÃO DE EVENTOS',
    detalhamento:
      'Suporte em eventos como Investor Day, roadshows, comitês setoriais e eventos institucionais.',
  },

  {
    key: '31',
    categoria: 'CONSULTORIA E PROJETOS',
    item: 'ASSESSORIA DE IMPRENSA',
    detalhamento:
      'Relacionamento com imprensa por meio de assessoria parceira, incluindo gestão de crises, plano de comunicação estratégica, elaboração de press releases e distribuição para mailing segmentado.',
  },

  {
    key: '32',
    categoria: 'CONSULTORIA E PROJETOS',
    item: 'JURÍDICO-SOCIETÁRIO',
    detalhamento:
      'Acompanhamento e apoio técnico em temas societários: atas, assembleias, registros e atualizações legais.',
  },

  {
    key: '33',
    categoria: 'CONSULTORIA E PROJETOS',
    item: 'ECM & DCM',
    detalhamento:
      'Suporte estratégico em estruturação de dívida, emissões, follow-ons e demais operações no mercado de capitais.',
  },

  {
    key: '34',
    categoria: 'CONSULTORIA E PROJETOS',
    item: 'ESG',
    detalhamento:
      'Construção de materiais e relatórios ESG com certificação GRI, desde a coleta de dados, elaboração de materialidade, redação e diagramação.',
  },

  {
    key: '35',
    categoria: 'CONSULTORIA E PROJETOS',
    item: 'BENCHMARK',
    detalhamento:
      'Estudo comparativo voltado para análise de pares, mercado e setor. Relatório analítico com insights a respeito das melhores práticas, por exemplo, na estruturação do release de resultados, formato e meios de divulgação, conteúdo das apresentações e site de RI.',
  },

  {
    key: '36',
    categoria: 'CONSULTORIA E PROJETOS',
    item: 'PERCEPTION',
    detalhamento:
      'Aplicação e análise de estudos de percepção junto a investidores, analistas e stakeholders estratégicos. Relatório analítico com insights e indicadores de desempenho (KPIs) da área de RI.',
  },

  {
    key: '37',
    categoria: 'CONSULTORIA E PROJETOS',
    item: 'AWARENESS',
    detalhamento:
      'Diagnóstico e desenvolvimento de programa de comunicação focado em aumento de liquidez e redução de custo de capital. ',
  },

  {
    key: '38',
    categoria: 'ADMINISTRATIVO',
    item: 'FINANCEIRO E CONTRATOS',
    detalhamento:
      'Apoio administrativo para temas como: atualização de cadastro, detalhamento de faturas, verificação de débitos, NDA, reajuste contratual, renovação ou cancelamento. ',
  },
];

interface FormData {
  service: ServiceItem;
  message: string;
  priority: 'alto' | 'medio' | 'baixo';
  emails: string[];
  files: File[];
}

const ServiceTable = () => {
  const [searchText, setSearchText] = useState('');
  const [selectedService, setSelectedService] = useState<ServiceItem | null>(null);
  const [filteredItems, setFilteredItems] = useState<ServiceItem[]>(dataSource);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingTimeout, setLoadingTimeout] = useState<NodeJS.Timeout | null>(null);
  const drawer = useDisclosure();
  const { getAuthUser } = useAuth();
  const companyId = useCurrentCompanyId();
  const { data: companiesResponse } = useMyCompanies({});

  const handleServiceRequest = async (
    service: ServiceItem,
    requestMessage: string,
    priority: 'alto' | 'medio' | 'baixo',
    formData: FormData,
  ) => {
    try {
      const user = getAuthUser();

      if (!user) {
        throw new Error('Usuário não está autenticado');
      }

      const currentCompany = companiesResponse?.data?.data?.find(
        (company) => company.id === companyId,
      );

      if (!currentCompany) {
        throw new Error(
          'Empresa não encontrada. Por favor, verifique se você está logado com a empresa correta.',
        );
      }

      const organizationName = currentCompany.name;

      const requester = {
        name: user.displayName || 'Nome do Usuário',
        email: user.email || 'email@organizacao.com',
      };

      if (!requester.email || !requester.email.includes('@')) {
        throw new Error('Email do solicitante inválido');
      }

      if (!requestMessage?.trim()) {
        throw new Error('A mensagem é obrigatória');
      }

      if (!service?.item?.trim()) {
        throw new Error('O serviço é obrigatório');
      }

      const ticketMessage = [
        'Mensagem do solicitante:',
        requestMessage,
        '',
        'Detalhes adicionais:',
        `- Empresa: ${organizationName}`,
        `- Serviço: ${service.item}`,
        `- Categoria: ${service.categoria}`,
        `- Emails para contato: ${formData.emails?.join(', ') || 'Não especificado'}`,
      ].join('\n');

      const response = await createServiceTicket(
        organizationName,
        service,
        ticketMessage,
        requester,
        {
          to: [],
          emails: formData.emails,
          files: formData.files,
        },
        undefined,
        priority,
      );

      if (response.success || response.data) {
        message.success('Solicitação enviada com sucesso!');
        return;
      }

      throw new Error('Resposta inesperada do Zendesk');
    } catch (error) {
      if (
        error instanceof Error &&
        error.message.includes('ERR_FAILED') &&
        error.message.includes('201')
      ) {
        message.success('Solicitação enviada com sucesso!');
        return;
      }

      throw error;
    }
  };

  const renderServiceCard = (item: ServiceItem) => (
    <Card
      key={item.key}
      title={item.item}
      className="service-card"
      extra={
        <Button
          type="primary"
          onClick={() => {
            setSelectedService(item);
            drawer.open();
          }}
        >
          Solicitar
        </Button>
      }
    >
      <p>{item.detalhamento}</p>
    </Card>
  );

  const renderTabContent = (category?: string) => {
    const items = category
      ? filteredItems.filter((item) => item.categoria === category)
      : filteredItems;

    if (isLoading) {
      return (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
          <Spin size="large" />
        </div>
      );
    }

    if (searchText && items.length === 0) {
      return <Empty description="Nenhum serviço encontrado" />;
    }

    return (
      <div className="service-cards-container">
        {items.map(renderServiceCard)}
      </div>
    );
  };

  const items: TabsProps['items'] = [
    {
      key: 'visao-geral',
      label: 'VISÃO GERAL',
      children: <div>{renderTabContent()}</div>,
    },
    {
      key: 'suporte',
      label: 'SUPORTE',
      children: <div>{renderTabContent('SUPORTE')}</div>,
    },
    {
      key: 'atendimento',
      label: 'ATENDIMENTO CVM/B3',
      children: <div>{renderTabContent('ATENDIMENTO CVM/B3')}</div>,
    },
    {
      key: 'consultoria',
      label: 'CONSULTORIA E PROJETOS',
      children: <div>{renderTabContent('CONSULTORIA E PROJETOS')}</div>,
    },
    {
      key: 'administrativo',
      label: 'ADMINISTRATIVO',
      children: <div>{renderTabContent('ADMINISTRATIVO')}</div>,
    },
  ];

  return (
    <div style={{ width: '100%'}}>
      <div style={{ marginBottom: 16 }}>
        <Input
          placeholder="Pesquisar..."
          allowClear
          prefix={<SearchOutlined />}
          style={{ width: 300 }}
          value={searchText}
          onChange={(e) => {
            const filterValue = e.target.value.toLowerCase();
            setSearchText(e.target.value);

            if (loadingTimeout) {
              clearTimeout(loadingTimeout);
            }

            setIsLoading(true);

            const timeout = setTimeout(() => {
              if (filterValue) {
                const filtered = dataSource.filter(
                  (item) =>
                    item.item.toLowerCase().includes(filterValue) ||
                    item.detalhamento.toLowerCase().includes(filterValue),
                );
                setFilteredItems(filtered);
              } else {
                setFilteredItems(dataSource);
              }
              setIsLoading(false);
            }, 300);

            setLoadingTimeout(timeout);
          }}
        />
      </div>
      <div className="service-tabs-wrapper">
        <Tabs defaultActiveKey="visao-geral" items={items} className="service-tabs" style={{ width: '100%' }} />
      </div>

      {selectedService && (
        <ServiceRequestDrawer
          isOpen={drawer.isOpen}
          onClose={drawer.close}
          service={selectedService}
          onSubmit={handleServiceRequest}
        />
      )}
    </div>
  );
};

export default ServiceTable;
